import { useTranslation } from 'react-i18next';

/**
 * Custom hook for language management
 * Provides translation function and language switching capabilities
 */
export const useLanguage = () => {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng: 'pt' | 'en') => {
    i18n.changeLanguage(lng);
  };

  const getCurrentLanguage = () => i18n.language;

  const isPortuguese = () => i18n.language === 'pt';
  const isEnglish = () => i18n.language === 'en';

  return {
    t,
    changeLanguage,
    getCurrentLanguage,
    currentLanguage: i18n.language,
    isPortuguese,
    isEnglish,
  };
};

export default useLanguage;
